enum AdminAnnouncementPageDisplayEnum {
    LOGIN = 'login',
    GLOBAL = 'global',
}

export default AdminAnnouncementPageDisplayEnum;
